import React from 'react'
import styled from 'styled-components'
import {Link} from 'gatsby'
import { graphql,useStaticQuery } from 'gatsby'
import useWindowsSize from './hooks/useWindowsSize'
import NavbarMenu from './Header/Navbar'
const HeaderWrapper = styled.div`
display: flex;
flex-direction:column;
align-items: center;

`
const HeaderLogo = styled(Link)`
font-family: 'Babe Sans';
font-style: normal;
font-weight: 400;
font-size: 60px;
line-height: 50px;
letter-spacing: -0.5px;
@media screen and (max-width:300px)
{
  font-size: 40px;
}
`
const HeaderMenu = styled.div`
  svg{
    cursor: pointer;
  }
    flex: 1;
    display: flex;
    justify-content: flex-end;
`
const HeaderFlex = styled.div`
display: flex;
flex-direction: row;
width:100%;
align-items: center;
`
const HeaderSticky =  styled.div`
display: none;
flex-direction:column;
align-items: center;

`
const HeaderStickyLogo = styled(Link)`
font-family: 'Babe Sans';
font-style: normal;
font-weight: 400;
font-size: 40px;
line-height: 50px;
letter-spacing: -0.5px;
@media screen and (max-width:300px)
{
  font-size: 40px;
}
`
function Header() {
  const {width} = useWindowsSize()
  console.log(width)
  React.useEffect(()=>
  {
    if(window !== "undefined"){
      const navbar = document.querySelector('.navbar')
      if(width >'500')
      {
        navbar.classList.remove('stickyy')
        const height = navbar.offsetHeight
        const y_pos = navbar.offsetTop
       document.addEventListener('scroll', e =>{
         const scroll= window.scrollY
         if(scroll >height + y_pos) 
         {
         navbar.classList.add('sticky')
         }else if (scroll <= y_pos + 200)
         {
          navbar.classList.remove('sticky')
         }
       })
      }
      else if(width  <= '500')
      {
        navbar.classList.add('stickyy')
      }
     
  }
  },[width])
  const [isMenu,setMenu] = React.useState(false)
  const [isNavbar,setNavbar] = React.useState(false)
  const handleClick = () =>
  {
    setMenu(!isMenu)
  }
  React.useEffect(()=>
  {
    if(isMenu)
    {
      setNavbar(true)

    }
    else
    {
      setNavbar(false)
     
    }
    
  }, [isMenu])


  return (
    <>
      <HeaderWrapper className='navbar'>
      <HeaderFlex className='menu'>
      <HeaderLogo className='navbar_title' to='/'>
      Al Sabab
      </HeaderLogo>
      <HeaderMenu className='ismenu'>
        {!isMenu ?
(
  <svg onClick={handleClick} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3 8H21C21.2652 8 21.5196 7.89464 21.7071 7.70711C21.8946 7.51957 22 7.26522 22 7C22 6.73478 21.8946 6.48043 21.7071 6.29289C21.5196 6.10536 21.2652 6 21 6H3C2.73478 6 2.48043 6.10536 2.29289 6.29289C2.10536 6.48043 2 6.73478 2 7C2 7.26522 2.10536 7.51957 2.29289 7.70711C2.48043 7.89464 2.73478 8 3 8ZM21 16H3C2.73478 16 2.48043 16.1054 2.29289 16.2929C2.10536 16.4804 2 16.7348 2 17C2 17.2652 2.10536 17.5196 2.29289 17.7071C2.48043 17.8946 2.73478 18 3 18H21C21.2652 18 21.5196 17.8946 21.7071 17.7071C21.8946 17.5196 22 17.2652 22 17C22 16.7348 21.8946 16.4804 21.7071 16.2929C21.5196 16.1054 21.2652 16 21 16ZM21 11H3C2.73478 11 2.48043 11.1054 2.29289 11.2929C2.10536 11.4804 2 11.7348 2 12C2 12.2652 2.10536 12.5196 2.29289 12.7071C2.48043 12.8946 2.73478 13 3 13H21C21.2652 13 21.5196 12.8946 21.7071 12.7071C21.8946 12.5196 22 12.2652 22 12C22 11.7348 21.8946 11.4804 21.7071 11.2929C21.5196 11.1054 21.2652 11 21 11Z" fill="black"/>
</svg>
):
(
  <svg onClick={handleClick} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17.6569 16.2427L13.4143 12L17.6569 7.7574C17.8444 7.56986 17.9498 7.31551 17.9498 7.05029C17.9498 6.78508 17.8444 6.53072 17.6569 6.34319C17.4694 6.15565 17.215 6.05029 16.9498 6.05029C16.6846 6.05029 16.4302 6.15565 16.2427 6.34319L12 10.5858L7.7574 6.34319C7.56986 6.15565 7.31551 6.05029 7.05029 6.05029C6.78508 6.05029 6.53072 6.15565 6.34319 6.34319C6.15565 6.53072 6.05029 6.78508 6.05029 7.05029C6.05029 7.31551 6.15565 7.56986 6.34319 7.7574L10.5858 12L6.34319 16.2427C6.15565 16.4302 6.05029 16.6846 6.05029 16.9498C6.05029 17.215 6.15565 17.4694 6.34319 17.6569C6.53072 17.8444 6.78508 17.9498 7.05029 17.9498C7.31551 17.9498 7.56986 17.8444 7.7574 17.6569L12 13.4143L16.2427 17.6569C16.4302 17.8444 16.6846 17.9498 16.9498 17.9498C17.215 17.9498 17.4694 17.8444 17.6569 17.6569C17.8444 17.4694 17.9498 17.215 17.9498 16.9498C17.9498 16.6846 17.8444 16.4302 17.6569 16.2427Z" fill="black"/>
</svg>
)
        }
      </HeaderMenu>
      </HeaderFlex>
     {isNavbar &&
     (
      <NavbarMenu />
     )
     }
      
      

     
    </HeaderWrapper>
    </>
  
  )
}

export default Header